module.exports = __webpack_public_path__ + "img/chouqian-sticks.6218f260.png";